<template>
  <div class="" v-if="isUserReady">
    <zt-header-bar ref="headerBar" style="margin-right:0px!important">
      <template slot="header-logo">
        <div class="logo-company-container px-2 relative cursor-pointer" @click="$router.push('/')">
          <logo-company :user-id="user.empresa.id" />
        </div>
      </template>
      <template slot="header-actions">
        <div class="flex relative hidden lg:block">
          <div class="flex items-center">
            <div class="relative flex justify-center" v-if="filteredByActionsOptions.length > 0">
              <div class="has-tooltip flex justify-center ">
                <button ref="optionsButton"
                  class="pl-0 inline-flex items-center justify-center w-12 h-12 gray-color bg-white rounded-full hover:bg-gray-200"
                  @click="isOptionsExpanded = !isOptionsExpanded">
                  <svg aria-hidden="true" class="w-5 h-5 gray-color" fill="none" stroke="currentColor"
                    viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                  </svg>
                </button>
                <span class="tooltip p-2 rounded text-white">{{
                  $t('message.HeaderComponent.search')
                  }}</span>
              </div>
              <transition>
                <div v-show="isOptionsExpanded" v-closable="{ exclude: ['optionsButton'], handler: 'onClose' }"
                  class="rounded shadow-lg overflow-hidden absolute mt-16 bg-white p-2">
                  <div v-for="(option, index) in filteredByActionsOptions" :key="index"
                    class="cursor-pointer hover:bg-zt-dark-100 px-2 text-zt-dark-400 flex w-full last:border-0 h-16"
                    @click="handleOptionClick(option)">
                    <div
                      class="cursor-pointer hover:bg-zt-dark-100 px-2 text-zt-dark-400 flex last:border-0 h-16 w-1/6 mr-4">
                      <zt-icon :name="option.icon" class="pointer-events-none text-zt-primary-200" :class="option.iconClass ? option.iconClass : 'text-zt-xl'
                        " />
                    </div>
                    <div class="pointer-events-none text-left text-zt-dark-500 py-3 items-start w-full font-bold">
                      <span class="pointer-events-none text-zt-sm">{{
                        option.title
                        }}</span>
                    </div>
                  </div>
                </div>
              </transition>
            </div>

            <div class="flex justify-center has-tooltip ">
              <a :href="userHelpLink" target="_blank">
                <zt-button color="primary" text icon="question-circle" class="navbar-button gray-color" fab />
              </a>
              <span class="tooltip p-2 rounded text-white">{{
                $t('message.HeaderComponent.help')
                }}</span>
            </div>

            <div class="relative flex justify-center"
              v-if="dataLinkUsersModalArray.length > 0 && mergeCandidates.length > 0">
              <div class="has-tooltip flex justify-center ">
                <button ref="button"
                  class="pl-0 inline-flex items-center justify-center w-12 h-12 gray-color bg-white rounded-full hover:bg-gray-200"
                  @click="isNotificationsExpanded = !isNotificationsExpanded">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24">
                    <path fill="currentColor" fill-rule="evenodd"
                      d="M12 1.25A7.75 7.75 0 0 0 4.25 9v.704a3.53 3.53 0 0 1-.593 1.958L2.51 13.385c-1.334 2-.316 4.718 2.003 5.35c.755.206 1.517.38 2.284.523l.002.005C7.567 21.315 9.622 22.75 12 22.75s4.433-1.435 5.202-3.487l.002-.005a28.472 28.472 0 0 0 2.284-.523c2.319-.632 3.337-3.35 2.003-5.35l-1.148-1.723a3.53 3.53 0 0 1-.593-1.958V9A7.75 7.75 0 0 0 12 1.25m3.376 18.287a28.46 28.46 0 0 1-6.753 0c.711 1.021 1.948 1.713 3.377 1.713c1.429 0 2.665-.692 3.376-1.713M5.75 9a6.25 6.25 0 1 1 12.5 0v.704c0 .993.294 1.964.845 2.79l1.148 1.723a2.02 2.02 0 0 1-1.15 3.071a26.96 26.96 0 0 1-14.187 0a2.021 2.021 0 0 1-1.15-3.07l1.15-1.724a5.03 5.03 0 0 0 .844-2.79z"
                      clip-rule="evenodd" />
                  </svg>
                </button>
                <span v-if="notifications" class="notifications">{{

                  }}</span>
                <span class="tooltip p-2 rounded text-white">{{
                  $t('message.HeaderComponent.notifications')
                  }}</span>
              </div>
              <div class="flex items-center justify-center">
                <zt-off-canvas position="right" max-width="480px" :active="isNotificationsExpanded"
                  @close="isNotificationsExpanded = false">
                  <div class="w-full flex align-center p-4 border-b">
                    <zt-button @click="isNotificationsExpanded = !isNotificationsExpanded" color="secondary"
                      icon="times" text fab data-vs-button="open-close-notifications"></zt-button>
                    <h2 class="text-zt-xl">{{ $t('message.HeaderComponent.notifications') }}</h2>
                  </div>
                  <div class="rounded border overflow-hidden absolute mt-4 bg-white p-4 mx-4 ">
                    <div class="p-4 ">
                      <div class="flex justify-between align-center ">

                        <h2 class="text-zt-primary-200 text-zt-xl">{{ $t('message.HeaderComponent.accountsLinked') }}
                        </h2>

                      </div>
                      <p class="py-4">{{ $t('message.HeaderComponent.onlyOneAccount') }}</p>
                      <div>
                        <zt-button @click="goToLinkUserAccounts()" outlined data-vs-button="to-link-user">{{
                          $t('message.HeaderComponent.goAccountsLinked') }}</zt-button>
                      </div>
                    </div>
                  </div>
                </zt-off-canvas>
              </div>
            </div>
            <div class="flex justify-center has-tooltip " v-if="hasAnyApplication || hasTimeManagementApp">
              <button ref="applicationsButton"
                class="pl-0 inline-flex items-center justify-center w-12 h-12 gray-color bg-white rounded-full hover:bg-gray-200"
                @click="isApplicationExpanded = !isApplicationExpanded">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="w-5 h-5 gray-color"
                  viewBox="0 0 16 16">
                  <path
                    d="M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2z" />
                </svg>
              </button>
              <span class="tooltip p-2 rounded text-white">{{
                $t('message.HeaderComponent.apps')
                }}</span>
              <transition>
                <div v-show="isApplicationExpanded" v-closable="{ exclude: ['applicationsButton'], handler: 'oncloseApps' }"
                  class="rounded shadow-lg overflow-hidden absolute mt-16 bg-white p-2">
                  <div class="off-canvas-body p-4">
                    <a v-if="showApplication('SABA')" class="flex items-center p-2 application-link"
                      @click.prevent="redirectToApp('SABA')">
                      <i class="app-icon mr-4">
                        <svg version="1.1" id="svg2" xml:space="preserve" x="0px" y="0px"
                          viewBox="0 0 177.60506 198.4704" sodipodi:docname="78b5673377f49bfb967752ce6d4a0c5a-04.pdf"
                          xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                          xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                          xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
                          <defs id="defs6">
                            <clipPath clipPathUnits="userSpaceOnUse" id="clipPath16">
                              <path d="M 0,148.853 H 133.204 V 0 H 0 Z" id="path14" />
                            </clipPath>
                          </defs>
                          <sodipodi:namedview id="namedview4" pagecolor="#ffffff" bordercolor="#666666"
                            borderopacity="1.0" inkscape:pageshadow="2" inkscape:pageopacity="0.0"
                            inkscape:pagecheckerboard="0" />
                          <g id="g8" inkscape:groupmode="layer" inkscape:label="78b5673377f49bfb967752ce6d4a0c5a-04"
                            transform="matrix(1.3333333,0,0,-1.3333333,0,198.4704)">
                            <g id="g10">
                              <g id="g12" clip-path="url(#clipPath16)">
                                <g id="g18" transform="translate(66.602,109.2985)">
                                  <path
                                    d="M 0,0 -36.875,21.442 -56.53,10.071 C -62.703,6.335 -66.602,-0.325 -66.602,-7.473 V -29.89 l 7.635,-4.385 z"
                                    style="fill:#73c175;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path20" />
                                </g>
                                <g id="g22" transform="translate(125.5688,75.0231)">
                                  <path
                                    d="m 0,0 7.635,4.548 v 22.255 c 0,7.147 -3.899,13.807 -10.072,17.382 L -22.062,55.576 -58.967,34.275 Z"
                                    style="fill:#73c175;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path24" />
                                </g>
                                <g id="g26" transform="translate(133.2035,70.4743)">
                                  <path d="M 0,0 V 9.097 L -7.635,4.549 Z"
                                    style="fill:#51b45f;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path28" />
                                </g>
                                <g id="g30" transform="translate(7.6347,75.0231)">
                                  <path d="M 0,0 58.967,-34.275 117.934,0 58.967,34.275 Z"
                                    style="fill:#51b45f;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path32" />
                                </g>
                                <g id="g34" transform="translate(103.5072,130.5993)">
                                  <path
                                    d="m 0,0 -26.834,15.573 c -6.173,3.574 -13.97,3.574 -20.143,0 L -73.78,0.142 -36.905,-21.301 Z"
                                    style="fill:#83c780;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path36" />
                                </g>
                                <g id="g38" transform="translate(29.831,19.4323)">
                                  <path
                                    d="m 0,0 26.699,-15.397 c 6.173,-3.574 13.97,-3.574 20.143,0 L 73.396,-0.078 36.771,21.315 Z"
                                    style="fill:#2f9145;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path40" />
                                </g>
                                <g id="g42" transform="translate(-1e-4,79.4089)">
                                  <path d="m 0,0 v -8.935 l 7.635,4.549 z"
                                    style="fill:#51b45f;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path44" />
                                </g>
                                <g id="g46" transform="translate(7.6347,75.0231)">
                                  <path
                                    d="m 0,0 -7.635,-4.549 v -22.255 c 0,-7.147 3.899,-13.807 10.072,-17.381 l 19.759,-11.406 36.771,21.316 z m 117.934,0 -58.967,-34.275 36.626,-21.394 19.905,11.321 c 6.172,3.737 10.071,10.397 10.071,17.544 v 22.255 z"
                                    style="fill:#3da550;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path48" />
                                </g>
                                <g id="g50" transform="translate(123.1322,32.4626)">
                                  <path
                                    d="m 0,0 -46.459,-26.966 c -6.173,-3.573 -13.97,-3.573 -20.143,0 L -113.061,0 c -6.172,3.574 -10.071,10.234 -10.071,17.382 v -1.625 c 0,-7.148 3.899,-13.808 10.071,-17.381 l 46.459,-26.804 c 6.173,-3.573 13.97,-3.573 20.143,0 L 0,-1.624 C 6.173,1.949 10.071,8.609 10.071,15.757 v 1.625 C 10.071,10.234 6.173,3.574 0,0"
                                    style="fill:#2f9145;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path52" />
                                </g>
                                <g id="g54" transform="translate(67.5014,93.3874)" />
                                <g id="g56" transform="translate(66.602,1.2927)">
                                  <path
                                    d="m 0,0 c 9.516,0 17.23,-0.29 17.23,-0.646 0,-0.357 -7.714,-0.647 -17.23,-0.647 -9.517,0 -17.231,0.29 -17.231,0.647 C -17.231,-0.29 -9.517,0 0,0"
                                    style="fill:#d1d1d1;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path58" />
                                </g>
                                <g id="g60" transform="translate(104.7846,84.0944)">
                                  <path
                                    d="m 0,0 c -0.506,1.558 -1.888,2.661 -3.516,2.808 l -22.202,2.016 -8.775,20.542 c -0.648,1.51 -2.122,2.485 -3.762,2.485 -1.641,0 -3.116,-0.975 -3.76,-2.485 L -50.789,4.824 -72.995,2.808 C -74.623,2.658 -76.001,1.555 -76.511,0 c -0.506,-1.557 -0.038,-3.265 1.193,-4.345 l 16.783,-14.717 -4.948,-21.794 c -0.362,-1.603 0.259,-3.26 1.589,-4.221 0.715,-0.52 1.555,-0.778 2.397,-0.778 0.725,0 1.449,0.191 2.096,0.579 l 19.146,11.447 19.141,-11.447 c 1.405,-0.839 3.17,-0.763 4.497,0.199 1.33,0.961 1.952,2.618 1.59,4.221 l -4.949,21.794 16.784,14.717 C 0.038,-3.265 0.506,-1.56 0,0"
                                    style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none" id="path62" />
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </i>
                      <span>{{ $t('message.HeaderComponent.sichernTalent') }}</span>
                    </a>
                    <a v-if="showApplication('SICHERN_UNITE')" class="flex items-center p-2 application-link"
                      @click.prevent="redirectToApp('SICHERN_UNITE')">
                      <i class="app-icon mr-4">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 40 40"
                          style="enable-background:new 0 0 40 40;" xml:space="preserve">
                          <g>
                            <path fill="#0B7AC0" d="M13.57,13.39c-0.81,0-1.47-0.66-1.47-1.48v-0.86c0-1.49-1.21-2.71-2.7-2.71c-1.57,0-2.79,1.21-2.79,2.71v0.86
		c0,0.82-0.66,1.48-1.47,1.48c-0.81,0-1.47-0.66-1.47-1.48v-0.86c0-3.12,2.53-5.66,5.65-5.66c3.2,0,5.73,2.54,5.73,5.66v0.86
		C15.04,12.73,14.38,13.39,13.57,13.39" />
                            <path fill="#0B7AC0" d="M34.87,13.39c-0.81,0-1.47-0.66-1.47-1.48v-0.86c0-1.49-1.21-2.71-2.7-2.71c-1.57,0-2.79,1.21-2.79,2.71v0.86
		c0,0.82-0.66,1.48-1.47,1.48c-0.81,0-1.47-0.66-1.47-1.48v-0.86c0-3.12,2.53-5.66,5.65-5.66c3.2,0,5.73,2.54,5.73,5.66v0.86
		C36.34,12.73,35.68,13.39,34.87,13.39" />
                            <path fill="#0B7AC0" d="M9.87,15.1c1.93,0,3.49,1.61,3.49,3.6v2.1c0,3.64,2.87,6.6,6.39,6.6c3.72,0,6.59-2.96,6.59-6.6v-2.1
		c0-1.99,1.56-3.6,3.49-3.6c1.93,0,3.49,1.61,3.49,3.6v2.1c0,7.61-6,13.81-13.37,13.81c-7.57,0-13.57-6.19-13.57-13.81v-2.1
		C6.39,16.71,7.95,15.1,9.87,15.1" />
                          </g>
                        </svg>
                      </i>
                      <span>{{ $t('message.HeaderComponent.sichernUnite') }}</span>
                    </a>
                    <a v-if="showApplication('GEOVICTORIA')" class="flex items-center p-2 application-link"
                      @click.prevent="redirectToApp('GEOVICTORIA')">
                      <i class="app-icon mr-4">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 256.7 286.9"
                          style="enable-background:new 0 0 256.7 286.9;" xml:space="preserve">
                          <g>
                            <g>
                              <g>
                                <path class="st0"
                                  d="M128.3,76.2L57.3,34.9L19.4,56.8C7.5,64,0,76.9,0,90.6v43.2l14.7,8.5L128.3,76.2z"
                                  fill="#F48E7D" />
                                <path class="st0"
                                  d="M242,142.3l14.7-8.8V90.6c0-13.8-7.5-26.6-19.4-33.5l-37.8-22l-71.1,41L242,142.3z"
                                  fill="#F48E7D" />
                                <path class="st1" d="M256.7,151v-17.5l-14.7,8.8L256.7,151z" fill="#F37D62" />
                                <path class="st1" d="M14.7,142.3l113.6,66.1L242,142.3L128.3,76.2L14.7,142.3z"
                                  fill="#F37D62" />
                                <path class="st2"
                                  d="M199.5,35.2l-51.7-30c-11.9-6.9-26.9-6.9-38.8,0L57.3,34.9l71.1,41.3L199.5,35.2z"
                                  fill="#F69C90" />
                                <path class="st3"
                                  d="M57.5,249.4l51.5,29.7c11.9,6.9,26.9,6.9,38.8,0l51.2-29.5l-70.6-41.2L57.5,249.4z"
                                  fill="#E56445" />
                                <path class="st1" d="M0,133.8V151l14.7-8.8L0,133.8z" fill="#F37D62" />
                                <path class="st4" d="M242,142.3l-113.6,66.1l70.6,41.2l38.4-21.8c11.9-7.2,19.4-20,19.4-33.8V151L242,142.3z M14.7,142.3L0,151
              				v42.9c0,13.8,7.5,26.6,19.4,33.5l38.1,22l70.9-41.1L14.7,142.3z" fill="#F37752" />
                                <path id="Self-shadow_1_" class="st3" d="M237.3,224.3l-89.5,52c-11.9,6.9-26.9,6.9-38.8,0l-89.5-52C7.5,217.4,0,204.6,0,190.8
              				v3.1c0,13.8,7.5,26.6,19.4,33.5l89.5,51.7c11.9,6.9,26.9,6.9,38.8,0l89.5-51.7c11.9-6.9,19.4-19.7,19.4-33.5v-3.1
              				C256.7,204.6,249.2,217.4,237.3,224.3z" fill="#E56445" />
                              </g>
                            </g>
                            <g id="Shadow_3_">
                              <ellipse class="st5" cx="128.3" cy="285.6" rx="33.2" ry="1.2" fill="#D1D1D1" />
                            </g>
                            <g>
                              <path class="st6" d="M128.6,71.2c-39.2,0-71,31.8-71,71s31.8,71,71,71s71-31.8,71-71S167.8,71.2,128.6,71.2L128.6,71.2z
              			 M174.5,148.2h-45.9c-3.3,0-5.9-2.7-5.9-5.9V96.4c0-3.3,2.6-5.9,5.9-5.9c3.3,0,5.9,2.7,5.9,5.9v40h40c3.3,0,5.9,2.7,5.9,5.9
              			C180.4,145.5,177.7,148.2,174.5,148.2L174.5,148.2z M174.5,148.2" fill="#FFFFFF" />
                            </g>
                          </g>
                        </svg>
                      </i>
                      <span>{{ $t('message.HeaderComponent.sichernTime') }}</span>
                    </a>
                    <div v-if="timeManagementApp.url">
                      <form id="VPTimeManagement" :action="timeManagementApp.url" method="post" target="_blank">
                        <input type="hidden" name="token" :value="timeManagementApp.token"
                          data-vs-input="token-input" />
                        <input type="hidden" name="idBase" :value="timeManagementApp.tenant"
                          data-vs-input="tenant-input" />
                        <button type="submit" class="flex items-center p-2 application-link"
                          data-vs-button="submit-time-management-site">
                          <i class="app-icon mr-4">
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 256.7 286.9"
                              style="enable-background:new 0 0 256.7 286.9;" xml:space="preserve">
                              <g>
                                <g>
                                  <g>
                                    <path class="st0"
                                      d="M128.3,76.2L57.3,34.9L19.4,56.8C7.5,64,0,76.9,0,90.6v43.2l14.7,8.5L128.3,76.2z"
                                      fill="#F48E7D" />
                                    <path class="st0"
                                      d="M242,142.3l14.7-8.8V90.6c0-13.8-7.5-26.6-19.4-33.5l-37.8-22l-71.1,41L242,142.3z"
                                      fill="#F48E7D" />
                                    <path class="st1" d="M256.7,151v-17.5l-14.7,8.8L256.7,151z" fill="#F37D62" />
                                    <path class="st1" d="M14.7,142.3l113.6,66.1L242,142.3L128.3,76.2L14.7,142.3z"
                                      fill="#F37D62" />
                                    <path class="st2"
                                      d="M199.5,35.2l-51.7-30c-11.9-6.9-26.9-6.9-38.8,0L57.3,34.9l71.1,41.3L199.5,35.2z"
                                      fill="#F69C90" />
                                    <path class="st3"
                                      d="M57.5,249.4l51.5,29.7c11.9,6.9,26.9,6.9,38.8,0l51.2-29.5l-70.6-41.2L57.5,249.4z"
                                      fill="#E56445" />
                                    <path class="st1" d="M0,133.8V151l14.7-8.8L0,133.8z" fill="#F37D62" />
                                    <path class="st4" d="M242,142.3l-113.6,66.1l70.6,41.2l38.4-21.8c11.9-7.2,19.4-20,19.4-33.8V151L242,142.3z M14.7,142.3L0,151
                          v42.9c0,13.8,7.5,26.6,19.4,33.5l38.1,22l70.9-41.1L14.7,142.3z" fill="#F37752" />
                                    <path id="Self-shadow_1_" class="st3" d="M237.3,224.3l-89.5,52c-11.9,6.9-26.9,6.9-38.8,0l-89.5-52C7.5,217.4,0,204.6,0,190.8
                          v3.1c0,13.8,7.5,26.6,19.4,33.5l89.5,51.7c11.9,6.9,26.9,6.9,38.8,0l89.5-51.7c11.9-6.9,19.4-19.7,19.4-33.5v-3.1
                          C256.7,204.6,249.2,217.4,237.3,224.3z" fill="#E56445" />
                                  </g>
                                </g>
                                <g id="Shadow_3_">
                                  <ellipse class="st5" cx="128.3" cy="285.6" rx="33.2" ry="1.2" fill="#D1D1D1" />
                                </g>
                                <g>
                                  <path class="st6" d="M128.6,71.2c-39.2,0-71,31.8-71,71s31.8,71,71,71s71-31.8,71-71S167.8,71.2,128.6,71.2L128.6,71.2z
                        M174.5,148.2h-45.9c-3.3,0-5.9-2.7-5.9-5.9V96.4c0-3.3,2.6-5.9,5.9-5.9c3.3,0,5.9,2.7,5.9,5.9v40h40c3.3,0,5.9,2.7,5.9,5.9
                        C180.4,145.5,177.7,148.2,174.5,148.2L174.5,148.2z M174.5,148.2" fill="#FFFFFF" />
                                </g>
                              </g>
                            </svg>
                          </i>
                          {{ $t('message.HeaderComponent.timeManagement') }}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <div class="text-zt-lg lg:hidden" v-if="currentRouteMeta !== 'home'">
              {{ currentRouteMeta }}
            </div>
            <hr class="h-10 border-l border-gray-600 mr-3 ml-2" />
          </div>
        </div>
        <div :class="[
          { 'pointer-events-none': !showActionChangeMoreCompany },
          { hidden: currentRouteMeta !== 'home' }
        ]" class="zt-gtm-header-switch-company text-white lg:text-zt-secondary-200 flex justify end"
          @click="switchCompany">
          <span class="pointer-events-none lg:hidden">
            {{ user.empresa.nombre }}
            <zt-icon class="pointer-events-none" name="angle-down" v-if="showActionChangeMoreCompany" />
          </span>
        </div>
      </template>
      <template slot="header-avatar">
        <div class="has-tooltip">
          <button class="hover:bg-gray-200 p-2 pr-3 rounded flex items-center gray-color"
            style="border: 1px solid #CCCCCC;" @click="isUserMenuOpen = !isUserMenuOpen">
            <div class="flex px-2 nowrap">{{ user.empresa.nombre }}</div>
            <zt-avatar :src="getAvatar" :text="getAvatarText" size="25px" />
          </button>
          <div class="tooltip p-2 rounded text-white mt-1 toolpit-right">
            <div class="flex flex-col">
              <span>{{ userNameBusiness }}</span>
              <span>{{ user.mail }}</span>
              <span>{{ $t('message.HeaderComponent.company') }}:
                {{ user.empresa.nombre }}</span>
            </div>
          </div>
        </div>
      </template>
      <template slot="header-list-item">
        <div class="flex flex-col menuHeader justify-start pl-4 pb-2">
          <div>
            <zt-avatar :src="getAvatar" :text="getAvatarText" size="62px" />
          </div>
          <div class="font-bold">{{ getAvatarText }}</div>
          <div class="text-zt-dark-400">{{ getUser.mail }}</div>
        </div>
        <div v-for="(item, index) in menuItems" :key="index" class="flex flex-col">
          <div class="cursor-pointer hover:bg-zt-dark-200 px-4 text-zt-dark-400 flex w-full last:border-0 h-16"
            :class="[{ 'lg:hidden': item.to === 'changeTo' }, item.tagClass]" @click="redirectTo(item.to)">
            <div class="w-10 flex item-center pointer-events-none">
              <zt-icon :name="item.icon" class="pointer-events-none text-zt-primary-200"
                :class="item.iconClass ? item.iconClass : 'text-zt-xl'" />
            </div>
            <div
              class="pointer-events-none block text-left text-zt-dark-500 leading-none py-3 ml-4 items-center w-full font-bold"
              :class="haveSubTitleMenu(item.subtitle)">
              <span class="pointer-events-none block text-zt-sm">{{
                item.title
                }}</span>
              <span class="pointer-events-none font-light block mt-1 text-zt-xs tracking-wider" v-if="item.subtitle">{{
                item.subtitle }}</span>
            </div>
            <div v-if="item.title === 'Rol'" class="self-center">
              <zt-icon v-if="expanded" name="angle-up" />
              <zt-icon v-else name="angle-down" />
            </div>
            <div class="self-center">
              <div v-if="item.id === 'companyManager' && isMobile" class="self-center">
                <zt-icon v-if="isChangeCompanyExpanded" name="angle-up" class="self-center" />
                <zt-icon v-else name="angle-down" class="self-center" />
              </div>
            </div>
          </div>
          <div v-if="expanded && item.title === 'Rol'" class="mb-2 px-4 bg-zt-dark-100">
            <div v-for="submenu in item.subMenu" class="flex w-full py-3 cursor-pointer" :key="submenu.title"
              @click="setChangeRole(submenu.id)">
              <div class="mr-4 text-zt-primary-200">
                <zt-icon :name="submenu.icon" class="text-zt-xl" />
              </div>
              <div class="flex-auto ml-2">
                <p class="text-zt-sm text-zt-dark-500 font-bold">
                  {{ submenu.title }}
                </p>
              </div>
              <div>
                <zt-icon v-if="submenu.isActive" name="check-circle" />
                <zt-icon v-else name="sync" />
              </div>
            </div>
          </div>
          <div v-if="isChangeCompanyExpanded && item.id === 'companyManager'" class="mb-2  pl-2 pr-4 bg-zt-dark-100">
            <div v-for="userRelated in getUsersRelated" class="flex w-full align-center cursor-pointer"
              :key="userRelated.empresa.id" @click="managerSwitchCompany(userRelated)">
              <div class="w-11 h-auto">
                <div
                  class="w-16 h-16 md:w-16 md:h-20 flex justify-center items-center mx-auto border rounded border-custom-gray-2">
                  <div class="logo-company-change-box flex items-center justify-center ">
                    <img :src="userRelated.empresa.companyLogo" alt="" />
                  </div>
                </div>
              </div>
              <div class="w-3/6 md:w-2/4 py-4 flex flex-wrap ml-4">
                <span class="w-full font-bold text-zt-dark-500">{{
                  userRelated.empresa.nombre
                  }}</span>
                <span class="w-full company-info">{{ userRelated.pais }}</span>
              </div>
              <div>
                <zt-icon v-if="
                  !userRelated.blockedByPayment &&
                  userRelated.empresa.id == currentCompany
                " name="check-circle" />
                <zt-icon v-else-if="
                  !userRelated.blockedByPayment &&
                  userRelated.empresa.id != currentCompany
                " name="sync" />
                <div v-else class=" my-auto flex justify-start items-end border-custom-red">
                  {{
                    $t(
                      'message.settingsComponent.list.switchCompany.blockedCompany'
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </zt-header-bar>
    <zt-modal :active="modalActive" @close="modalActive = false" :max-width="modalWidth" :z-index="200"
      :fullscreen="isMobile">
      <template slot="modal-header">
        <div class="p-4 font-normal text-zt-lg text-center md:text-left">
          <h4>{{ titleModal }}</h4>
        </div>
      </template>
      <component :is="componentBodyModal" @close="modalActive = false" :userEmail="user.mail" @success="activeStatus"
        @logout="logoutMfa" @switch-company="showSuccessModal" />
    </zt-modal>
    <!-- Modal switch user success -->
    <zt-modal :active="modalSuccess.active" persistent @close="modalSuccess.active = false" :max-width="'48rem'"
      :z-index="9999">
      <template slot="modal-header">
        <div class="p-4 font-bold text-zt-lg">
          <h4>{{ titleModal }}</h4>
        </div>
      </template>
      <div class="w-full md:pt-6 flex">
        <div class="w-11/12 flex py-2">
          <div class="p-6 w-1/4 md:p-12">
            <svg xmlns="http://www.w3.org/2000/svg" :width="isMobile ? 50 : 80" :height="isMobile ? 50 : 80" fill="none"
              viewBox="0 0 91 91">
              <path fill="#fff"
                d="M71.692 29.368l-1.759-1.759c-.818-.859-2.29-.859-3.231 0-9.164 9.327-18.369 18.573-27.573 27.818-4.868-4.99-9.777-9.9-14.646-14.809-.9-.9-2.372-.9-3.272 0-.573.573-1.105 1.187-1.678 1.76-.9.818-.9 2.331 0 3.231l17.223 17.346c1.923 1.963 2.823 1.963 4.746 0 10.022-10.146 20.127-20.25 30.15-30.355.94-.9.94-2.332.04-3.232z" />
              <path fill="#54CAA6"
                d="M45.633.82c-24.832 0-45 20.21-45 45 0 24.832 20.168 45 45 45 24.79 0 45-20.168 45-45s-20.168-45-45-45z" />
              <path fill="#fff"
                d="M72.183 29.368l-1.718-1.759c-.819-.859-2.332-.859-3.232 0-9.164 9.327-18.368 18.573-27.573 27.818-4.868-4.99-9.777-9.9-14.645-14.809-.9-.9-2.373-.9-3.273 0-.573.573-1.105 1.187-1.677 1.76-.9.818-.9 2.331 0 3.231l17.222 17.346c1.923 1.963 2.823 1.963 4.746 0C52.056 52.809 62.16 42.705 72.183 32.6c.9-.9.9-2.332 0-3.232z" />
            </svg>
          </div>
          <div class="w-3/4 md:py-4 flex justify-start items-center">
            <span class="text-zt-lg md:text-zt-xl text-zt-dark-500">
              {{ $t('message.settingsComponent.list.switchCompany.success') }}
            </span>
          </div>
        </div>
      </div>
      <template slot="modal-footer">
        <div class="zt-modal-footer flex justify-end items-center p-4 bg-zt-dark-100">
          <zt-button @click="changeCompanySuccess">
            {{ $t('message.settingsComponent.list.okMsg') }}
          </zt-button>
        </div>
      </template>
    </zt-modal>
    <zt-modal :active="managerChangingModal" persistent @close="modalSuccess.active = false" :max-width="'30rem'"
      :z-index="9999">
      <div class="p-8">
        <h1 class="text-2xl pb-2">{{ $t('message.settingsComponent.list.businessChange') }}</h1>
        <div>
          <p class="text-lg font-bold custom-color-neutral py-2">{{ $t('message.settingsComponent.list.authentic') }}
          </p>
          <div class="flex align-center bg-gray-300 rounded-2xl p-2">
            <div class="w-11 h-auto">
              <div
                class="w-16 h-16 md:w-16 md:h-20 flex justify-center items-center mx-auto border rounded border-custom-gray-2">
                <div class="logo-company-change-box flex items-center justify-center ">
                  <img :src="companyChangedTo.companyLogo" alt="" />
                </div>
              </div>
            </div>
            <div class="w-2/6 md:w-3/4  flex flex-wrap ml-4">
              <span class="w-full font-bold text-zt-dark-500">{{
                companyChangedTo.nombre
              }}</span>
              <span class="w-full company-info">{{ companyChangedTo.pais }}</span>
            </div>
            <div>
              <zt-icon name="sync" />
            </div>
          </div>
        </div>
      </div>
    </zt-modal>
    <link-user-modal v-if="dataLinkUsersModalArray.length > 0" :linkUsersModalActive="linkUsersModalActive"
      :isMobile="isMobile" @update:linkUsersModalActive="linkUsersModalActive = $event" @notifyLater="notifyLater" />
  </div>
</template>

<script>
import logoCompany from '../commons/LogoCompany'
import { mapGetters, mapState, mapActions } from 'vuex'
import editMail from './modals/EditMail'
import editPass from './modals/EditPassword'
import mfaSettings from './modals/MfaSettings'
import switchCompany from './modals/SwitchCompany'
import { useWindowResize } from '@sichern/ui-elements'
import { isEmpty, filter, find, remove, some, has } from 'lodash'
import { storeMutationOffCanvas } from '@/components/MenuBar/hooks/offcanvas'
import Users from '../../apiClient/Users'
import Vue from 'vue'
import SichernIntegration from '@/apiClient/SichernIntegration';
import UsersLink from '@/apiClient/UsersLink'
import LinkUserModal from '@/modules/LinkUser/components/LinkUserModal'
// import { helpHeroService } from '@/services/helpHeroService';

Vue.directive('closable', {
  bind(el, binding, vnode) {
    const handleOutsideClick = e => {
      e.stopPropagation();
      const { handler, exclude } = binding.value;
      let clickedOnExcludedEl = false;

      if (typeof vnode.context[handler] !== 'function') {
        return;
      }

      (exclude || []).forEach(refName => {
        const excludedEl = vnode.context.$refs[refName];
        if (!clickedOnExcludedEl && excludedEl) {
          clickedOnExcludedEl = excludedEl.contains(e.target);
        }
      });

      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]();
      }
    };

    el.__vueHandleOutsideClick__ = handleOutsideClick;
    document.addEventListener('click', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);
  },
  unbind(el) {
    const handleOutsideClick = el.__vueHandleOutsideClick__;
    if (handleOutsideClick) {
      document.removeEventListener('click', handleOutsideClick);
      document.removeEventListener('touchstart', handleOutsideClick);
    }
  }
});

export default {
  name: 'ZtHeader',
  inject: ['mutations'],
  components: {
    logoCompany,
    editMail,
    editPass,
    switchCompany,
    LinkUserModal
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      modalActive: false,
      modalSuccess: {
        active: false,
        lastUserId: '',
        currentUser: {},
        companyState: ''
      },
      modalWidth: '',
      userAvatar: '',
      titleModal: '',
      componentBodyModal: '',
      windowResize: useWindowResize(this),
      keepAliveInterval: '',
      companyUrl: '',
      expanded: false,
      notifications: 10,
      isChangeCompanyExpanded: false,
      companyChangedTo: [],
      managerChangingModal: false,
      linkUsersModalActive: false,
      dataLinkUsersModalArray: [],
      menu: [
        {
          title: this.$t('message.settingsComponent.changeTo'),
          subtitle: '',
          icon: 'applications',
          to: 'changeTo',
          tagClass: ''
        },
        {
          title: this.$t('message.settingsComponent.changeBussiness'),
          subtitle: '',
          icon: 'switch',
          to: 'switchCompany',
          tagClass: 'zt-gtm-menu-user-switch-company',
          id: 'companyDesktop'
        },
        {
          title: this.$t('message.settingsComponent.rolTitle'),
          subtitle: this.$t('message.settingsComponent.changeVisualization'),
          icon: 'my-team-horizontal',
          to: 'switchRole',
          tagClass: '',
          subMenu: [
            {
              title: this.$t('message.settingsComponent.managerTitle'),
              icon: 'my-team-horizontal',
              isActive: this.$store.state.isManagerRole
            },
            {
              title: this.$t('message.settingsComponent.colaboradorTitle'),
              icon: 'person',
              isActive: !this.$store.state.isManagerRole
            }
          ]
        },
        {
          title: this.$t('message.settingsComponent.changeBussiness'),
          subtitle: this.$t('message.settingsComponent.'),
          icon: 'switch',
          to: 'managerSwitchCompany',
          tagClass: '',
          id: 'companyManager'
        },
        {
          title: this.$t('message.settingsComponent.myAccount'),
          subtitle: this.$t('message.settingsComponent.changePesonalData'),
          icon: 'person',
          to: 'myCount',
          tagClass: ''
        },
        {
          title: this.$t('message.settingsComponent.editPassword'),
          subtitle: this.$t('message.settingsComponent.changeAccessKey'),
          icon: 'lock-outline-stroke',
          to: 'password',
          tagClass: ''
        },
        {
          title: this.$t('message.settingsComponent.editEmail'),
          subtitle: this.$t('message.settingsComponent.changePersonalEmail'),
          icon: 'envelop',
          to: 'email',
          iconClass: 'text-zt-lg',
          tagClass: ''
        },
        {
          title: this.$t('message.settingsComponent.securityAdds'),
          subtitle: this.$t('message.settingsComponent.authPreferences'),
          icon: 'shield-check-outline',
          to: 'mfa',
          tagClass: ''
        },
        {
          title: this.$t('message.settingsComponent.privacyPolicy'),
          subtitle: '',
          icon: 'file-info-circle',
          to: 'private',
          tagClass: ''
        },
        {
          title: this.$t('message.settingsComponent.getOut'),
          icon: 'door-arrow-right',
          to: 'login',
          iconClass: 'ml-1 text-zt-xl',
          tagClass: ''
        }
      ],
      isOptionsExpanded: false,
      isApplicationExpanded: false,
      currentCompany: '',
      applications: {},
      searchOptions: [
        {
          title: this.$t('message.settingsComponent.documents'),
          icon: 'file',
          to: '/documents/search',
          action: '3'
        },
        {
          title: this.$t('message.settingsComponent.collab'),
          icon: 'person',
          to: '/search',
          action: '53'
        },

        {
          title: this.$t('message.settingsComponent.licencesCollab'),
          icon: 'calendar-day',
          to: '/licenses',
          action: '90'
        }
      ],
      timeManagementApp: {},
      isNotificationsExpanded: false,
    }
  },
  computed: {
    ...mapState(['user', 'usersRelated', 'actions']),
    ...mapGetters({
      getUser: 'getUser',
      getUsersRelated: 'getUsersRelated',
      getAvatarHeader: 'getAvatarHeader',
      getCompanyLoginUrl: 'getCompanyLoginUrl',
      getIsManagerRole: 'getIsManagerRole',
    }),
    hasAnyApplication() {
      return Object.keys(this.applications).length
    },
    hasTimeManagementApp() {
      return Object.keys(this.timeManagementApp).length
    },
    isManager() {
      return this.user.perfiles.some(
        objeto => objeto.id_perfil_tipo === 8
      )
    },
    userNameBusiness() {
      return this.user.nickname + ' ' + '(' + this.user.dni + ')'
    },
    getAvatar() {
      return this.getAvatarHeader
    },
    getAvatarText() {
      return !this.getAvatarHeader
        ? this.user.nombre + ' ' + this.user.apellido
        : ''
    },
    getCompanyLogin() {
      return this.getCompanyLoginUrl
    },
    isMobile() {
      return this.windowResize.width < 1024
    },
    currentRouteMeta() {
      return this.$route.meta.titleHeader
    },
    showActionChangeMoreCompany() {
      let usersRelatedPerfilEmployee = 0
      filter(this.usersRelated, related => {
        find(related.perfiles, perfil => {
          if (perfil.id_perfil_tipo === 1) usersRelatedPerfilEmployee++
        })
      })
      return usersRelatedPerfilEmployee > 1
    },
    isUserReady() {
      return !isEmpty(this.user)
    },
    isSelfServiceActive() {
      const result = this.actions.some(objeto => ['201', '202', '203', '204'].includes(objeto.id))
      return result
    },
    menuItems() {
      let menu = [...this.menuOptions]
      if (!(this.isManager && this.isMobile && this.showActionChangeMoreCompany)) {
        menu = menu.filter(item => item.id !== 'companyManager')
      }
      if ((this.isManager && this.isMobile && this.showActionChangeMoreCompany)) {
        menu = menu.filter(item => item.id !== 'companyDesktop')
      }
      if (!(this.isManager && this.isMobile)) {
        menu = menu.filter(objeto => objeto.id !== 'role')
      }
      if (!this.showActionChangeMoreCompany) {
        menu = menu.filter(item => item.id !== 'companyDesktop')
      }
      if (!this.isSelfServiceActive) {
        menu = menu.filter(item => item.id !== 'myAccount')
      }
      return menu
    },
    showApplicationSABA() {
      return (
        some(
          this.actions,
          action =>
            action.id === '100' || action.id === '101' || action.id === '102'
        ) && this.getUser.estado_empresa === 1
      )
    },
    filteredByActionsOptions() {
      const actionsIds = this.actions.map(action => action.id)
      const filtered = this.searchOptions.filter(option =>
        actionsIds.includes(option.action)
      )
      return filtered
    },
    mergeCandidates() {
      return this.$store.state.linkUserMergeCandidates
    },
    menuOptions() {
      return [
        {
          title: this.$t('message.settingsComponent.changeTo'),
          subtitle: '',
          icon: 'applications',
          to: 'changeTo',
          tagClass: ''
        },
        {
          title: this.$t('message.settingsComponent.changeBussiness'),
          subtitle: '',
          icon: 'switch',
          to: 'switchCompany',
          tagClass: 'zt-gtm-menu-user-switch-company',
          id: 'companyDesktop'
        },
        {
          title: this.$t('message.settingsComponent.rolTitle'),
          subtitle: this.$t('message.settingsComponent.changeVisualization'),
          icon: 'my-team-horizontal',
          to: 'switchRole',
          id: 'role',
          tagClass: '',
          subMenu: [
            {
              title: this.$t('message.settingsComponent.managerTitle'),
              icon: 'my-team-horizontal',
              isActive: this.$store.state.isManagerRole,
              id: 'managerRole'
            },
            {
              title: this.$t('message.settingsComponent.colaboradorTitle'),
              icon: 'person',
              isActive: !this.$store.state.isManagerRole,
              id: 'employeeRole'
            }
          ]
        },
        {
          title: this.$t('message.settingsComponent.changeBussiness'),
          subtitle: this.$t('message.settingsComponent.changeAnotherBusiness'),
          icon: 'switch',
          to: 'managerSwitchCompany',
          tagClass: '',
          id: 'companyManager'
        },
        {
          title: this.$t('message.settingsComponent.myAccount'),
          subtitle: this.$t('message.settingsComponent.changePesonalData'),
          icon: 'person',
          to: 'myCount',
          id: 'myAccount',
          tagClass: ''
        },
        {
          title: this.$t('message.settingsComponent.editPassword'),
          subtitle: this.$t('message.settingsComponent.changeAccessKey'),
          icon: 'lock-outline-stroke',
          to: 'password',
          tagClass: ''
        },
        {
          title: this.$t('message.settingsComponent.editEmail'),
          subtitle: this.$t('message.settingsComponent.changePersonalEmail'),
          icon: 'envelop',
          to: 'email',
          iconClass: 'text-zt-lg',
          tagClass: ''
        },
        {
          title: this.$t('message.settingsComponent.securityAdds'),
          subtitle: this.$t('message.settingsComponent.authPreferences'),
          icon: 'shield-check-outline',
          to: 'mfa',
          tagClass: ''
        },
        {
          title: this.$t('message.settingsComponent.privacyPolicy'),
          subtitle: '',
          icon: 'file-info-circle',
          to: 'private',
          tagClass: ''
        },
        {
          title: this.$t('message.settingsComponent.getOut'),
          icon: 'door-arrow-right',
          to: 'login',
          iconClass: 'ml-1 text-zt-xl',
          tagClass: ''
        }
      ]
    },
    iframeTokenValid() {
      return this.$iframeMessages.isTokenValid()
    },
    userHelpLink() {
      return 'https://sichernsa.freshdesk.com/support/solutions/folders/13000021053'
    }
  },
  async created() {
    // this.setHelpHero()
    this.companyChangedTo = this.$store.state.user
    this.usersClient = new Users()
    this.usersLink = new UsersLink()
    this.vi = new SichernIntegration();
    this.currentCompany = this.$store.state.user.empresa.id
    // this.canShowTimeManagementApp()
    this.changeTheme()
    if (this.showApplicationSABA) {
      const applicationsResponse = await this.usersClient.applicationsSAML()
      this.applications = applicationsResponse.data.data
    }
    await this.checkUsersLink()
    this.$store.dispatch('getAvatar', { userId: this.$store.state.user.id })
  },
  methods: {
    ...mapActions(['setInitialBoards', 'setUser', 'setActions', 'clearState', 'setCompanyLoginUrl', 'setLinkUserMergeCandidates']),
    async redirectTo(goTo) {
      switch (goTo) {
        case 'switchCompany':
          this.$refs.headerBar.closeMenu()
          this.switchCompany()
          break
        case 'password':
          this.componentBodyModal = editPass
          this.titleModal = this.$t('message.settingsComponent.list.changePassword.title')
          this.$refs.headerBar.closeMenu()
          this.modalActive = !this.modalActive
          this.modalWidth = '400px'
          break
        case 'email':
          this.componentBodyModal = editMail
          this.titleModal = this.$t('message.settingsComponent.list.changeEmail.title')
          this.$refs.headerBar.closeMenu()
          this.modalActive = !this.modalActive
          this.modalWidth = '400px'
          break
        case 'mfa':
          this.componentBodyModal = mfaSettings
          this.titleModal = this.$t('message.settingsComponent.securityAdds')
          this.$refs.headerBar.closeMenu()
          this.modalActive = !this.modalActive
          this.modalWidth = '43rem'
          break
        case 'private':
          const privacyUrls = {
            BR: 'https://community.sichern.com/t5/Sabias-que/POLITICA-DE-PRIVACIDADE-DA-PLATAFORMA-SICHERN/ta-p/727913',
            default: 'https://community.sichern.com/t5/Sabias-que/POLITICA-DE-PRIVACIDAD-DE-LA-PLATAFORMA-SICHERN/ta-p/567941'
          }
          const privacyUrl = this.user.pais === 'BR' ? privacyUrls.BR : privacyUrls.default
          window.open(privacyUrl, '_blank')
          this.$refs.headerBar.closeMenu()
          break
        case 'login':
          this.companyUrl = this.getCompanyLogin
          this.redirectToLogin()
          break
        case 'changeTo':
          storeMutationOffCanvas.setOffCanvasActive(true)
          this.$refs.headerBar.closeMenu()
          break
        case 'switchRole':
          this.expanded = !this.expanded
          break
        case 'managerSwitchCompany':
          this.isChangeCompanyExpanded = !this.isChangeCompanyExpanded
          break
        case 'myCount':
          this.$refs.headerBar.closeMenu()
          this.$router.push({ name: 'selfService' })
          break
      }
    },
    handleOptionClick(option) {
      if (option.url) {
        window.open(option.url, '_blank')
      } else if (option.to) {
        this.$router.push({ name: option.to }).catch(() => {})
      }
      this.isOptionsExpanded = false
    },
    async logoutMfa() {
      this.companyUrl = this.getCompanyLogin
      await this.usersClient.logOut()
      this.$store.dispatch('clearState')
      this.redirectToLogin()
    },
    redirectToLogin() {
      clearInterval(this.keepAliveInterval)
      localStorage.removeItem('jwt')
      this.$router.push({ name: 'logout' })
    },
    haveSubTitleMenu(subtitle) {
      return subtitle ? 'flex-auto' : 'flex'
    },
    activeStatus() {
      setTimeout(() => {
        this.modalActive = false
      }, 3000)
    },
    setChangeRole(managerRole) {
      this.$refs.headerBar.closeMenu()
      this.$refs.headerBar.closeMenu()
      const isManagerRole = managerRole !== 'employeeRole';
      this.$store.dispatch('isManagerRole', isManagerRole);
      this.$router.push(isManagerRole ? '/dashboard' : '/');

    },
    switchCompany() {
      this.componentBodyModal = switchCompany
      this.titleModal = this.$t('message.settingsComponent.list.switchCompany.title')
      this.modalActive = !this.modalActive
      this.modalWidth = '48rem'
    },
    showSuccessModal(value) {
      this.modalActive = false
      this.modalSuccess = {
        active: true,
        lastUserId: value.lastUserId,
        currentUser: value.currentUser,
        companyState: value.companyState
      }
    },
    changeCompanySuccess() {
      const currentPage = this.$router.currentRoute.name
      this.$store.dispatch('setStateNotOnboarding', true)
      this.$store.dispatch('clearUserDocuments')
      
      this.$store.dispatch('getLogoCompany', this.modalSuccess.currentUser.empresa.id)
      
      this.setInitialBoards()
      this.$router.push('/')
      this.modalSuccess = {
        active: false,
        currentUser: {}
      }
      if (this.modalSuccess.companyState === 2) {
        localStorage.setItem('jwt', this.$store.getters.getJwt)
        this.$store.dispatch('clearState')
        location.replace(
          window.location.origin + '/s/home/' + this.modalSuccess.lastUserId
        )
      }
      if (currentPage === 'home') {
        location.reload()
      }
    },
    validateChangeToMobile() {
      if (!this.showApplicationSABA) {
        remove(this.menuOptions, option => {
          return option.to === 'changeTo'
        })
      }
    },
    changeTheme() {
      const idEmpresa = this.user.empresa.id
      const file = document.createElement('link')
      const random = new Date().getTime()
      file.rel = 'stylesheet'
      file.href = `${window.sichern.brandingURL}/${idEmpresa}/style.css?${random}`
      file.onerror = () => {
        // Fallback: inyectar colores por defecto de Sichern si el CSS de branding falla
        const style = document.createElement('style')
        style.id = 'sichern-branding-fallback'
        if (!document.getElementById('sichern-branding-fallback')) {
          style.textContent = `:root {
  --branding-primary: #4F41A3;
  --branding-secondary: #DCC1FF;
  --branding-activeColor: #8672DB;
  --branding-titleColor: #4F41A3;
  --branding-textColor: #FFFFFF;
  --v-buttonPrimary-base: #4F41A3;
  --branding-lightThemeBg: #4F41A3;
}`
          document.head.appendChild(style)
        }
      }
      document.head.appendChild(file)
    },
    redirectToApp(app) {
      const urlApp = this.applications[app]
      window.open(urlApp, '_blank')
    },
    showApplication(app) {
      return has(this.applications, app)
    },
    onClose() {
      this.isOptionsExpanded = false
    },
    oncloseApps() {
      this.isApplicationExpanded = false
    },
    async managerSwitchCompany(userRelated) {

      if (userRelated.companyState !== 2)
        try {
          this.companyChangedTo = userRelated.empresa
          this.companyChangedTo.pais = userRelated.pais
          this.managerChangingModal = true
          this.$refs.headerBar.closeMenu()
          const userResponse = await this.usersClient.switchcompany(userRelated.id)
          const {
            data: {
              results: { data }
            }
          } = userResponse
          const user = data[0]
          this.currentCompany = user.empresa.id
          this.setUser({ user })
          if (user.aplicacion.dominio && user.aplicacion.dominio !== '') {
            this.setCompanyLoginUrl(user.aplicacion.dominio)
          }

          await this.$store.dispatch('getLogoCompany', user.empresa.id)

          await this.$store.dispatch('refreshSichernPeopleIntegration')

          await this.setActions({ replace: true }).catch(error => {
            this.$swal({
              type: 'error',
              title: this.$t(
                `message.errorReference.${error.response.data.response_v2.code}`
              ),
              showConfirmButton: true,
              confirmButtonText: this.$t('message.settingsComponent.list.okMsg')
            })
          })
          this.$store.dispatch('getAvatar', { userId: user.id })
          this.$store.dispatch('clearPayrollStatus')
          user.perfiles.some(objeto => objeto.id_perfil_tipo === 8) ? this.setChangeRole('managerRole') : this.setChangeRole('employeeRole')
          await this.$store.dispatch('setProfile', { replace: true })
          this.usersClient.getAvatarImage().then(response => {
            this.$emit('refreshAvatar', 'data:image/png;base64,' + response)
          })
          this.changeCompanySuccess()
          location.reload()
          this.managerChangingModal = false
          this.$refs.headerBar.closeMenu()

        } catch (error) {
          this.managerChangingModal = false
        }
    },
    async checkUsersLink() {
      // let prevRoute = localStorage.getItem('prevRoute')
      // if (prevRoute === 'login') {
      await this.usersLink
        .checkUsersLink()
        .then(res => {
          let data = res.data
          this.dataLinkUsersModalArray = data.candidates
          this.setLinkUserMergeCandidates(data.candidates)
          this.linkUsersModalActive = !data.notify_later
          this.notifications = data.notify_later


        })
        .catch(err => {
          // Handle USER_LINK_NOT_FOUND or other errors
          if (err.response && err.response.data && err.response.data.codes) {
            const errorCodes = err.response.data.codes
            const userLinkNotFound = errorCodes.some(code => code.code === 'USER_LINK_NOT_FOUND')
            
            if (userLinkNotFound) {
              // No users found to relate, reset the state
              this.dataLinkUsersModalArray = []
              this.setLinkUserMergeCandidates([])
              this.linkUsersModalActive = false
              this.notifications = false
            }
          }
          console.error('Error checking users link:', err)
        })
      // }
    },
    notifyLater() {
      this.usersLink.rememberLater()
      this.linkUsersModalActive = false
      this.notifications = true
    },
    async canShowTimeManagementApp() {
      const type = 'VP_TIME_MANAGEMENT';
      try {
        const { data: { data: { enabled } } } = await this.vi.checkIntegrationSichernPeople(type);
        if (enabled) {
          this.timeManagementApp = (await this.usersClient.timeManagementApplication()).data.data;
        }
        return enabled;
      } catch (error) {
        this.timeManagementApp = {}
      }
    },
    goToLinkUserAccounts() {
      this.isNotificationsExpanded = !this.isNotificationsExpanded
      this.$router.push({ name: 'LinkUser' })
    },
    setCompanyNameToClarity() {
      if (this.$store.state.profile && this.$store.state.profile.empresa) {
        const { nombre, id } = this.$store.state.profile.empresa;
        window.companyName = `${id} ${nombre}`;
        const event = new CustomEvent('companyNameSet', { detail: window.companyName });
        window.dispatchEvent(event);
      }
    },
  
    async hasAnyIntegration() {
      try {
        const { data: { data: raw } } = await this.vi.getIntegrations();
        return Object.values(raw).some((value) => {
          if (Array.isArray(value)) return value.length > 0;
          if (value && typeof value === 'object') {
            return 'status' in value ? value.status === true : true;
          }
          return false;
        });
      } catch (error) {
        console.error('Error fetching integrations for Survicate:', error);
        return false;
      }
    },
    async survicate() {
      // Removed legacy Survicate/sichern tracking
      return
    },
    // setHelpHero() {
    //   const { nombre, apellido, pais, id } = this.user;
    //   const userData = {
    //     name: `${nombre} ${apellido}`,
    //     country: pais,
    //     userId: id
    //   }
    //   helpHeroService(userData)
    // }
  },
  mounted() {
    if (window.self === window.top) {
      this.survicate()
    }
    // this.setHelpHero()
    this.validateChangeToMobile()
    this.mutations.setRef(this.$refs.headerBar)
    this.setCompanyNameToClarity()

  }

}
</script>

<style scoped lang="scss">
.logo-company-container {
  height: 64px;
}

.bg-zt-primary-200 {
  background-color: var(--branding-primary, --v-primary-base);
}

.text-zt-primary-200 {
  color: var(--branding-titleColor, var(--v-primary-base)) !important;
}

::v-deep .text-white.zt-gtm-header-switch-company {
  color: var(--branding-textColor, #e4527f);
}

.application-link {
  margin-left: 25px;
  border-radius: 5px;
  color: #2d2d2d;

  .app-icon {
    width: 40px;
    height: 40px;
    background: #f1f1f1;
    border-radius: 5px;
  }

  &:hover {
    background: #e7e7e7;
  }
}

.application-link.no-ml {
  margin-left: 0;
}

@media (min-width: 1024px) {
  .lg\:bg-white {
    background-color: #fff;
  }

  .text-white.zt-gtm-header-switch-company {
    color: var(--branding-titleColor, #e4527f);
  }

  .tooltip {
    visibility: hidden;
    position: absolute;
    margin-top: 4rem;
    background-color: #575757;
  }

  .toolpit-right {
    right: 2%;
  }

  .has-tooltip:hover .tooltip {
    visibility: visible;
  }

  .gray-color {
    color: #575757 !important;
  }

  .navbar-button {
    padding-right: 0px !important;
    font-size: 18px;
    width: 2.5em !important;
    height: 2.5em !important;
  }

  .menuHeader {
    align-items: center;
    padding: 0px 16px;
    gap: 10px;
    width: 290px;
    height: 155px;
    border-bottom: 1px solid #969696;
    border-radius: 4px 4px 0px 0px;
    align-self: stretch;
    flex-grow: 0;
  }

  .nowrap {
    white-space: nowrap;
  }
}

.company-info {
  color: #575757;
}

.border-custom-red {
  border-color: red;
  color: red;
  font-size: 0.875rem;
}

.notification-box {
  width: 401px;
}

::v-deep div.absolute.right-0.items-center.flex.justify-center {
  position: relative !important;
}

::v-deep div.flex.justify-center.items-center.lg\:w-full.lg\:mr-20 {
  margin-right: 0;
  justify-content: end;
}

.notifications {
  position: absolute;
  display: inline-block;
  direction: rtl;
  right: 8px;
  bottom: 21.5px;
  color: #fff;
  background-color: #bd1c1c;
  font-weight: 600;
  font-size: 1rem;
  border-radius: 100%;
  min-width: 30%;
  text-align: center;
  padding: 10px 5px 2px 5px;
  height: 10px;
}
</style>